export default "__VITE_ASSET__zJI55Dlt__"